export default __webpack_public_path__ + "static/media/Portfolio.b6e4d3a3.png";